<template lang="pug">
  #app
    v-app
      router-view
    notifications(group="foo", position="top right")
    loading(:active.sync="isLoading", :can-cancel="false")
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.min.css";
import firebase from "firebase";

export default {
  components: {
    Loading
  },
  data() {
    return {};
  },
  computed: {
    isLoading: function() {
      // console.log(this.$store.state.isLoading)
      return this.$store.state.isLoading;
    }
  },
  mounted() {
    const apiKey = "AIzaSyALQqJnB-xVrDFk0L_wUkPz13rTf73U5hg";
    const projectId = "rompeelmiedo-org";
    const messagingSenderId = "44327701902";
    const publicVapidKey =
      "BC79j9Son3XgHUTcIwp9bJBFZ7XsEdRgRVwxbr9zg9Er0EvDZeTDvpJNcKzYWhw3d9Tzs4_3LvAVZ8vwLNSTsbs";

    const config = {
      apiKey: apiKey,
      authDomain: `${projectId}.firebaseapp.com`,
      databaseURL: `https://${projectId}.firebaseio.com`,
      projectId: `${projectId}`,
      storageBucket: `${projectId}.appspot.com`,
      messagingSenderId: messagingSenderId
    };

    firebase.initializeApp(config);

    const messaging = firebase.messaging();
    messaging.usePublicVapidKey(publicVapidKey);

    messaging.onTokenRefresh(() => {
      messaging
        .getToken()
        .then(() => {
          // console.log('Token refreshed.');
        })
        .catch(() => {
          // console.log('Unable to retrieve refreshed token ', err);
        });
    });

    messaging.onMessage(payload => {
      // console.log('Message received. ', payload);
      this.$notify({
        group: "foo",
        type: "success",
        title: payload.notification.title,
        text: payload.notification.body
      });
    });

    messaging
      .requestPermission()
      .then(() => {
        // console.log('Notification permission granted.');
        messaging
          .getToken()
          .then(currentToken => {
            if (currentToken) {
              // console.log({ currentToken });
              //store.state.currentToken = currentToken;
            } else {
              // console.log('No Instance ID token available. Request permission to generate one.');
            }
          })
          .catch(() => {
            // console.log('An error occurred while retrieving token. ', err);
          });
      })
      .catch(() => {
        // console.log('Unable to get permission to notify.', err);
      });

  }
};
</script>

<style lang="scss" src="./app.scss">
</style>
